module.exports = __webpack_public_path__ + "static/media/biozyme.eeac6826.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/biozyme.png
// module id = 1300
// module chunks = 3